// import {disable_scroll} from '../functions/scroll';
// import {enable_scroll} from '../functions/scroll';

(function () {
    const burger = document?.querySelector('[data-burger]');
    const menu = document?.querySelector('[data-menu]');
    const menuItems = document?.querySelectorAll('[data-menu-item]');
    const overlay = document?.querySelector('[data-menu-overlay]');
    const header = document?.querySelector('.header');

    burger?.addEventListener('click', (e) => {
        burger?.classList.toggle('burger--active');
        menu?.classList.toggle('menu--active');
        header?.classList.toggle('active');
        overlay.classList.toggle('bg-black--active');

        if (menu?.classList.contains('menu--active')) {
            burger?.setAttribute('aria-expanded', 'true');
            burger?.setAttribute('aria-label', 'Закрыть меню');

            // disable_scroll();
        } else {
            burger?.setAttribute('aria-expanded', 'false');
            burger?.setAttribute('aria-label', 'Открыть меню');
            // enable_scroll();
        }
    });

    overlay?.addEventListener('click', () => {
        burger?.setAttribute('aria-expanded', 'false');
        burger?.setAttribute('aria-label', 'Открыть меню');
        burger.classList.remove('burger--active');
        menu.classList.remove('menu--active');
        header?.classList.remove('active');

        overlay.classList.remove('bg-black--active');
        // enable_scroll();
    });

    menuItems?.forEach(el => {
        el.addEventListener('click', () => {
            burger?.setAttribute('aria-expanded', 'false');
            burger?.setAttribute('aria-label', 'Открыть меню');
            burger.classList.remove('burger--active');
            menu.classList.remove('menu--active');
            header?.classList.remove('active');

            // enable_scroll();
            overlay.classList.remove('bg-black--active');

        });
    });
})();
